import LocalLanding from "./LocalLanding";
export default function LandingOeiras() {
    return (
        <LocalLanding
            city="Oeiras"
            canonicalSlug="remodelacoes-oeiras"
            hero="https://images.unsplash.com/photo-1722785516299-d285fb10b138?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        />
    );
}
